import React from "react";
import { feeTypeMapper, REQUIRED_UPFRONT } from "../../../util/constants";
import { required } from "../../../util/validators";
import FieldTextInput from "../../FieldTextInput/FieldTextInput";
import { formatMoney } from "../../../util/currency";
import css from './FeesInputFields.module.css';


const UsageMultipleChargeFieldMaybe = (props) => {
  const { usageMultipleCharges = [], intl, fetchLineItemsInProgress } = props;
  
    return (
      <>
        {usageMultipleCharges.map(charge => {
          const { feeType, rate, usageLabel, whenToApply } = charge;
          const isRequired = whenToApply === REQUIRED_UPFRONT;
          const validateMaybe = isRequired
            ? {
              validate: required(intl.formatMessage({ id: 'UsageMultipleChargeFieldMaybe.UsageMultipleCharges.required' }))
            }
            : {};
  
          return (
            <FieldTextInput
              type="number"
              className={css.usageField}
              id={feeType}
              name={feeType}
              label={intl.formatMessage(
                { id: 'UsageMultipleChargeFieldMaybe.UsageMultipleCharges.label' },
                { feeType:feeTypeMapper[feeType], text: usageLabel, rate: formatMoney(intl, rate), isRequired }
              )}
              {...validateMaybe}
              autoFocus={true}
              disabled={fetchLineItemsInProgress}
            />
          )
        })}
      </>
    )
  };

  export default UsageMultipleChargeFieldMaybe;